// extracted by mini-css-extract-plugin
module.exports = {"main-color-default":"#6d6aff","pinkred":"#ef1449","gray":"#202429"};